import styled from "styled-components";

export const Wrapper = styled.div`
display: flex;
position: relative;
width: 100%;
height: ${props => props.height ? props.height : '100%'};
flex-direction: column;
`;